import { CommonWriteCampaignProps } from 'apis/restaurant-api/merchant-admin/campaigns/api';
import { convertDecimalToMonetaryInt } from 'common/utils/currencyDecimals';

import { API_UNLIMITED_TOTAL_BUDGET_SUM, UNLIMITED_TOTAL_BUDGET_SUM } from '../../components/budget-section/constants';
import { CommonCampaignFormValues } from '../../types';

export type TransformCommonFormFieldsToApiProps = CommonCampaignFormValues & {
  currency: Currency;
  merchantId: string;
};

export const transformCommonFormFieldsToApi = (
  values: TransformCommonFormFieldsToApiProps,
): CommonWriteCampaignProps => ({
  totalBudgetSum:
    values.totalBudgetSum === UNLIMITED_TOTAL_BUDGET_SUM
      ? API_UNLIMITED_TOTAL_BUDGET_SUM
      : convertDecimalToMonetaryInt(Number(values.totalBudgetSum), values.currency),
  minBasketSize: Number(values.minBasketSize),
  firstPurchaseOnly: values.firstPurchaseOnly,
  perUserUsageLimit: values.usageType === 'indefinitely' ? undefined : Number(values.perUserUsageLimit),
  startDate: values.startDate,
  endDate: values.endDate,
  weeklySchedule: values.weeklySchedule || null,
  currency: values.currency,
  venueIds: values.venueIds,
  merchantId: values.merchantId,
  campaignId: values.campaignId,
});
